
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.35 13C4.88056 13 4.5 12.6194 4.5 12.15L4.5 3.85C4.5 3.38056 4.88056 3 5.35 3C5.81944 3 6.2 3.38056 6.2 3.85L6.2 12.15C6.2 12.6194 5.81944 13 5.35 13Z","fill":"#10001F"}}),_c('path',{attrs:{"d":"M10.6498 13C10.1804 13 9.79981 12.6194 9.79981 12.15L9.79987 3.84999C9.79988 3.38055 10.1804 3 10.6499 3C11.1193 3 11.4999 3.38056 11.4999 3.85001L11.4998 12.15C11.4998 12.6194 11.1193 13 10.6498 13Z","fill":"#10001F"}})])
          )
        }
      }
    